import { ShieldCheck } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface VerifiedBadgeProps {
  documentsVerifiedAt: string | null | undefined;
  loading?: boolean;
}

/**
 * Account-area verification pill. Renders only the green "Verified" badge
 * when the company has completed verification. Unverified state renders
 * nothing (the upload-prompt UI has been removed).
 */
export function VerifiedBadge({ documentsVerifiedAt, loading }: VerifiedBadgeProps) {
  if (loading) return null;
  if (!documentsVerifiedAt) return null;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              'hidden sm:inline-flex items-center gap-1 h-7 px-2.5 rounded-full cursor-help',
              'text-[10px] font-bold uppercase tracking-wider',
              'bg-success-subtle text-success border border-success/30',
            )}
          >
            <ShieldCheck className="h-3 w-3" />
            Verified
          </span>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-[240px] text-[11px] leading-snug">
          This account has completed LaneRunner's verification process.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
